"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function dtr(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M13.535 17.1586C13.535 18.0174 12.845 18.7141 11.993 18.7141C11.141 18.7141 10.4517 18.0174 10.4517 17.1579V6.81612C10.4517 5.95737 11.1417 5.26062 11.993 5.26062C12.8442 5.26062 13.535 5.95737 13.535 6.81687V17.1586ZM8.34499 17.1624C8.34998 17.4369 8.28217 17.7078 8.14845 17.9475C8.01474 18.1873 7.81989 18.3874 7.58374 18.5274C7.34888 18.6662 7.08106 18.7394 6.80824 18.7394C6.53542 18.7394 6.2676 18.6662 6.03274 18.5274C5.79673 18.3873 5.60203 18.1872 5.46845 17.9474C5.33487 17.7076 5.26717 17.4368 5.27224 17.1624V14.8374C5.26717 14.563 5.33487 14.2921 5.46845 14.0523C5.60203 13.8126 5.79673 13.6125 6.03274 13.4724C6.2676 13.3335 6.53542 13.2603 6.80824 13.2603C7.08106 13.2603 7.34888 13.3335 7.58374 13.4724C7.81975 13.6125 8.01445 13.8126 8.14803 14.0523C8.28161 14.2921 8.34931 14.563 8.34424 14.8374L8.34499 17.1624Z", fill: color }),
        React.createElement("path", { opacity: 0.5, d: "M18.728 13.0561C18.728 13.9148 18.038 14.6116 17.186 14.6116C16.334 14.6116 15.644 13.9141 15.644 13.0553V9.13059C15.644 8.27109 16.334 7.57434 17.186 7.57434C18.038 7.57434 18.728 8.27109 18.728 9.13059V13.0561Z", fill: color }));
}
exports["default"] = dtr;
//# sourceMappingURL=dtr.js.map